export const SUBSCRIBE_STATE = {
	default: 0,
	noSub: 1,
	haveSub: 2,
	editSub: 3,
	waitingUnsub: 4,
};

export enum SUBSCRIBE_STATE_ENUM {
	default,
	noSub,
	haveSub,
	editSub,
	waitingUnsub,
};